<script>
import DashboardNew from '@/ui-overrides/default/pages/dashboard-new.vue';
export default DashboardNew;
</script>
